export enum ROUTES {
  ACCOUNT = "/billing",
  ACCOUNT_LATEST = "/billing/latest",
  ACCOUNT_V2 = "/billing/v2",
  BILLING_MANAGEMENT = "/billing/manage",
  BILLING_LATEST_MANAGEMENT = "/billing/latest/manage",
}
